import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as CMSActions from "./store/actions";
import useMediaQuery from "app/hooks/useMediaQuery";
import "./Footer.css";

const ROOT = process.env.REACT_APP_CMS_STATIC;
const VERSION = process.env.REACT_APP_VERSION;
const HOST_GRUPO = process.env.REACT_APP_HOST_GRUPO_CS;

function Footer(props) {
  const dispatch = useDispatch();
  const is4K = useMediaQuery("(min-width: 3840px)");
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const isMobile = useMediaQuery("(max-width: 767px)");

  const [social, setSocial] = useState([]);
  const [logoGrupoCSFooter, setLogoGrupoCSFooter] = useState("");
  const [logoSitioFooter, setLogoSitioFooter] = useState("");
  const [press, setPress] = useState([]);

  const [leftLinks, setLeftLinks] = useState([]);
  const [centerLinks, setCenterLinks] = useState([]);
  const [rightLinks, setRightLinks] = useState([]);

  const { token } = useSelector(({ Base }) => Base.Token);
  const { imageLinks } = useSelector(({ footer }) => footer.footer);
  const { textLinks } = useSelector(({ footer }) => footer.footer);
  const { logoSitioWeb } = useSelector(({ footer }) => footer.footer);

  useEffect(() => {
    if (token) {
      !imageLinks && dispatch(CMSActions.getImageLinksFooter(token));
      !textLinks && dispatch(CMSActions.getTextLinksFooter(token));
      !logoSitioWeb && dispatch(CMSActions.getLogoSitioWebFooter(token));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (imageLinks) {
      setSocial(imageLinks.redesSociales[0].bag.contentItems);
      setLogoGrupoCSFooter(ROOT + imageLinks.logoFooter[0].logo.urls[0]);
      setPress(imageLinks.saladePrensa);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageLinks]);

  useEffect(() => {
    if (textLinks) {
      function iterateObject(object) {
        let result = [];
        let keys = Object.keys(object);
        for (let i = 0; i < keys.length; i++) {
          let clave = keys[i];
          let value = object[clave];
          result.push(value);
        }
        return result;
      }
      let leftTextLinks = iterateObject(textLinks.footerLeftLinks[0]);
      let centerTextLinks = iterateObject(textLinks.footerCenterLinks[0]);
      let rightTextLinks = iterateObject(textLinks.footerRightLinks[0]);
      setLeftLinks(leftTextLinks);
      setCenterLinks(centerTextLinks);
      setRightLinks(rightTextLinks);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textLinks]);

  useEffect(() => {
    logoSitioWeb &&
      logoSitioWeb.aCLogoUnaSolaTinta.length > 0 &&
      logoSitioWeb.aCLogoUnaSolaTinta[0].logo.urls.length > 0 &&
      setLogoSitioFooter(
        ROOT + logoSitioWeb.aCLogoUnaSolaTinta[0].logo.urls[0]
      );
  }, [logoSitioWeb]);

  return (
    <section id="footerSection" name="footerSection">
      <div
        className={`footer d-flex flex-column ${is4K && "contenedor-footer"}`}
      >
        <div
          className={`d-flex mb-4 ${
            isMobile ? "flex-column" : "justify-content-between"
          }`}
        >
          <div
            className={`d-flex justify-content-${
              isDesktop ? "start" : "center"
            } mt-3`}
            style={isDesktop ? { width: "33%" } : {}}
          >
            {social &&
              social.map((net, index) => {
                return (
                  net.uRL.url &&
                  net.imagen.urls[0] && (
                    <a
                      target="_blank"
                      key={index}
                      className="nav-link a_footer"
                      href={net.uRL.url}
                      rel="noreferrer"
                    >
                      <img
                        src={ROOT + net.imagen.urls[0]}
                        alt={net.displayText}
                      />
                    </a>
                  )
                );
              })}
          </div>
          {isDesktop ? (
            <div
              className="d-flex flex-column"
              style={isDesktop ? { width: "33%" } : {}}
            >
              {(logoSitioFooter || logoGrupoCSFooter) && (
                <div className="conteneder-logos-footer">
                  {logoSitioFooter && (
                    <div className="logos-footer">
                      <a
                        className="nav-link a_footer"
                        href="/"
                        rel="noreferrer"
                      >
                        <img src={logoSitioFooter} alt="CS Ahorro y Crédito" />
                      </a>
                    </div>
                  )}
                  {logoSitioFooter && logoGrupoCSFooter && (
                    <div className="separador-vertical" />
                  )}
                  {logoGrupoCSFooter && (
                    <div className="logos-footer">
                      <a
                        target="_blank"
                        className="nav-link a_footer"
                        href={HOST_GRUPO}
                        rel="noreferrer"
                      >
                        <img src={logoGrupoCSFooter} alt="GrupoCS" />
                      </a>
                    </div>
                  )}
                </div>
              )}
              <div className="text-white">
                Versión {VERSION} | &copy; {new Date().getFullYear()} Derechos
                Reservados
              </div>
            </div>
          ) : null}
          <div
            className={`d-flex justify-content-${
              isDesktop ? "end" : "center"
            } mt-3`}
            style={isDesktop ? { width: "33%" } : {}}
          >
            <div className="text-white mt-2">Sala de Prensa</div>
            {press && press.length > 0 && (
              <>
                {press[0].logoPrensaLink &&
                  press[0].logoPrensaLink.url &&
                  press[0].logoPrensa &&
                  press[0].logoPrensa.urls[0] && (
                    <div key="sala-prensa">
                      <a
                        target="_blank"
                        className="nav-link a_footer"
                        href={press[0].logoPrensaLink.url}
                        rel="noreferrer"
                      >
                        <img
                          src={ROOT + press[0].logoPrensa.urls[0]}
                          alt="Prensa"
                        />
                      </a>
                    </div>
                  )}
                {press[0].logoWhatsappLink &&
                  press[0].logoWhatsappLink.url &&
                  press[0].logoWhatsapp &&
                  press[0].logoWhatsapp.urls[0] && (
                    <div key="whatsapp">
                      <a
                        target="_blank"
                        className="nav-link a_footer"
                        href={press[0].logoWhatsappLink.url}
                        rel="noreferrer"
                      >
                        <img
                          src={ROOT + press[0].logoWhatsapp.urls[0]}
                          alt="Whatsapp"
                        />
                      </a>
                    </div>
                  )}
              </>
            )}
          </div>
        </div>
        <div
          className={`d-flex ${
            isMobile ? "flex-column" : "justify-content-between"
          }`}
        >
          <div
            className={`d-flex flex-column mb-4 ${
              isMobile ? "align-items-center" : "align-items-start"
            }`}
            style={isDesktop ? { width: "33%" } : {}}
          >
            {leftLinks &&
              leftLinks.map((link, index) => {
                return (
                  link.url !== null && (
                    <div key={index}>
                      <a
                        key={index}
                        className="nav-link a_footer"
                        href={link.url}
                        rel="noreferrer"
                      >
                        {link.text}
                      </a>
                    </div>
                  )
                );
              })}
          </div>
          {isDesktop ? (
            <div
              className="d-flex flex-column flex-grow-1 bd-highlight align-items-center"
              style={isDesktop ? { width: "33%" } : {}}
            >
              {centerLinks &&
                centerLinks.map((link, index) => {
                  return (
                    link.url !== null && (
                      <div key={index}>
                        <a
                          key={index}
                          className="nav-link a_footer"
                          href={HOST_GRUPO + link.url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {link.text}
                        </a>
                      </div>
                    )
                  );
                })}
            </div>
          ) : null}
          <div
            className={`d-flex flex-column mb-4 ${
              isMobile ? "align-items-center" : "align-items-end"
            }`}
            style={isDesktop ? { width: "33%" } : {}}
          >
            {rightLinks &&
              rightLinks.map((link, index) => {
                return (
                  link.url !== null && (
                    <div key={index}>
                      <a
                        key={index}
                        className="nav-link a_footer"
                        href={HOST_GRUPO + link.url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {link.text}
                      </a>
                    </div>
                  )
                );
              })}
          </div>
        </div>
        {isDesktop ? null : (
          <>
            <div className="d-flex flex-column align-items-center">
              {centerLinks &&
                centerLinks.map((link, index) => {
                  return (
                    link.url !== null && (
                      <div key={index}>
                        <a
                          key={index}
                          className="nav-link a_footer"
                          href={link.url}
                          rel="noreferrer"
                        >
                          {link.text}
                        </a>
                      </div>
                    )
                  );
                })}
            </div>
            <div className="d-flex flex-column">
              {(logoSitioFooter || logoGrupoCSFooter) && (
                <div className="conteneder-logos-footer">
                  {logoSitioFooter && (
                    <div className="logos-footer">
                      <a
                        className="nav-link a_footer"
                        href="/"
                        rel="noreferrer"
                      >
                        <img
                          src={logoSitioFooter}
                          alt="CS Corredora de Seguros"
                        />
                      </a>
                    </div>
                  )}
                  {logoSitioFooter && logoGrupoCSFooter && (
                    <div className="separador-vertical" />
                  )}
                  {logoGrupoCSFooter && (
                    <div className="logos-footer">
                      <a
                        target="_blank"
                        className="nav-link a_footer"
                        href={HOST_GRUPO}
                        rel="noreferrer"
                      >
                        <img src={logoGrupoCSFooter} alt="GrupoCS" />
                      </a>
                    </div>
                  )}
                </div>
              )}
              <div className="text-white">
                Versión {VERSION} | &copy; {new Date().getFullYear()} Derechos
                Reservados
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
}

export default Footer;
